import { LOCAL_STORAGE } from "@app/constants/local-storage";

export default class JWT {
  public static get() {
    return localStorage.getItem(LOCAL_STORAGE.JWT) || undefined;
  }
}
